const timezoneQueryKeys = {
    all: () => ['timezone'],
};

export { timezoneQueryKeys };
